import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { TranslationService } from './translation.service';
import { of } from 'rxjs';

@Injectable({
  providedIn : 'root',
  })
  export class RedirectResolver implements Resolve<any> {

  constructor(
    private translate: TranslationService,
  ) {
  }

  resolve() {
    this.translate.initLang();
    return of(true);
  }
}
